<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Observing Capabilities"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <l-csv-import @on-import="onObservingCapabilities" />
    </l-container>

    <l-csv-export :exportPlugin="exportPlugin" :show="observingCapabilities.length > 0" filename="observingCapabilities" />

    <hot-table :data="observingCapabilities" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="Begin Position" data="begin_position" read-only="true"></hot-column>
      <hot-column title="End Position" data="end_position" read-only="true"></hot-column>
      <hot-column title="Process Type" data="process_type_name" read-only="true"></hot-column>
      <hot-column title="Result Nature" data="result_nature_name" read-only="true"></hot-column>
      <hot-column title="Pollutant" data="pollutant_name" read-only="true"></hot-column>
      <hot-column title="Concentration" data="concentration_name" read-only="true"></hot-column>
      <hot-column title="Time step" data="timestep_name" read-only="true"></hot-column>
      <hot-column title="Sampling Point ID" data="sampling_point_id" read-only="true"></hot-column>
      <hot-column title="Process ID" data="process_id" read-only="true"></hot-column>
      <hot-column title="Sample ID" data="sample_id" read-only="true"></hot-column>
    </hot-table>
    <l-l-edit
      :showing="edit"
      @save="onSaveObservingCapabilities"
      @close="edit = false"
      :observingCapabilities="observingCapabilities"
      :processtypevalues="processtypevalues"
      :resultnaturevalues="resultnaturevalues"
      :pollutants="pollutants"
      :concentrations="concentrations"
      :timesteps="timesteps"
      :samplingpoints="samplingpoints"
      :processes="processes"
      :samples="samples"
      :selected="selected"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import ObservingCapabilitiesService from "./observingCapabilities.service";
import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";
import LCsvExport from '@/components/LCsvExport.vue';

export default {
  name: "observingCapabilities",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport,
    LCsvExport
  },
  data() {
    return {
      edit: false,
      loading: false,
      observingCapabilities: [],
      processtypevalues: [],
      processtypevalues: [],
      resultnaturevalues: [],
      pollutants: [],
      concentrations: [],
      timesteps: [],
      samplingpoints: [],
      processes: [],
      samples: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      isnew: false,
      selected: {},
      exportPlugin: {}
    };
  },
  mounted() {
    //this.settings.afterSelectionEnd = this.selectRowOnly;
    this.exportPlugin = this.$refs.hot.hotInstance.getPlugin("exportFile");
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.observingCapabilities = await ObservingCapabilitiesService.observingCapabilities();
      this.processtypevalues = await ObservingCapabilitiesService.processtypevalues();
      this.resultnaturevalues = await ObservingCapabilitiesService.resultnaturevalues();
      this.pollutants = await ObservingCapabilitiesService.pollutants();
      this.concentrations = await ObservingCapabilitiesService.concentrations();
      this.timesteps = await ObservingCapabilitiesService.timesteps();
      this.samplingpoints = await ObservingCapabilitiesService.samplingpoints();
      this.processes = await ObservingCapabilitiesService.processes();
      this.samples = await ObservingCapabilitiesService.samples();
    },
    // async deleteObservingCapabilities(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await ObservingCapabilitiesService.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Observing Capabilities deleted!");
    //   }
    // },
    async saveObservingCapabilities(ra) {
      const rowsAffected = await ObservingCapabilitiesService.update(ra);
      console.log("SAVED TO DB");
      const current = this.observingCapabilities.find(n => n.id == ra.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ra[prop];
          }
        }
      }
    },
    async importObservingCapabilities(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await ObservingCapabilitiesService.import(formData);
      this.observingCapabilities = await ObservingCapabilitiesService.observingCapabilities();
      Notify.success("Observing capabilities imported!");
    },
    async onObservingCapabilities(file) {
      await Notify.loadData(
        "Importing observing Capabilities",
        this.importObservingCapabilities,
        file
      );
    },
    onEditObservingCapabilities(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;
    },
    onNewObservingCapabilities(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteObservingCapabilities(t, o) {
      const endRow = o[0].end.row;
      const startRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              for (let index = startRow; index < endRow+1; index++) {
                var row = hot.getDataAtRow(index);
                const rowsAffected = await ObservingCapabilitiesService.delete(row[0]);
              }
              const activeEditor = hot.getActiveEditor();
              hot.alter('remove_row', startRow, endRow-startRow+1);
            }
          );
          Notify.success("Observing Capabilities deleted!");
        }
      }, "This will delete all data connected to this Observing Capability(ies). <br/><br/>Do you want to continue?");
    },

    async onSaveObservingCapabilities(observingcapabilities) {
      await Notify.loadData(
        "Saving changes to Observing Capabilities " + observingcapabilities.id,
        this.saveObservingCapabilities,
        observingcapabilities
      );
      this.selected = {};
    }
  }
};
</script>



